import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  financialReportingServiceConnector: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  financialReportingServiceConnector: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.financialReportingServiceConnector === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const financialReportingServiceConnector = new customer.FinancialReportingServiceConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt(process.env.VUE_APP_REPORT_HTTP_REQUEST_TIMEOUT, 10),
      });
      financialReportingServiceConnector.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      financialReportingServiceConnector.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.financialReportingServiceConnector = financialReportingServiceConnector;
    }
    return state.financialReportingServiceConnector;
  },
};

const actions = {
  async generateDisputeReport(context, {
    startDate, endDate, dateType, sort, filename,
  }) {
    try {
      const financialReportingServiceConnector = context.getters.financialReportingServiceConnector(context);
      const lang = context.rootGetters['language/selectedLanguage'];

      const params = { sort, filename, lang };

      if (dateType === 'payoutDate') {
        params.startPayoutDate = startDate;
        params.endPayoutDate = endDate;
      } else if (dateType === 'transactionDate') {
        params.startDate = startDate;
        params.endDate = endDate;
      } else if (dateType === 'evidenceDueDate') {
        params.startEvidenceDueDate = startDate;
        params.endEvidenceDueDate = endDate;
      } else {
        params.startDisputeDate = startDate;
        params.endDisputeDate = endDate;
      }

      const reportData = await financialReportingServiceConnector.generateDisputeReport(params);
      return reportData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'csvReport.generateDisputeReportError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async generateRefundReport(context, {
    startDate, endDate, dateType, sort, filename,
  }) {
    try {
      const financialReportingServiceConnector = context.getters.financialReportingServiceConnector(context);
      const lang = context.rootGetters['language/selectedLanguage'];

      const params = { sort, filename, lang };

      if (dateType === 'payoutDate') {
        params.startPayoutDate = startDate;
        params.endPayoutDate = endDate;
      } else if (dateType === 'transactionDate') {
        params.startDate = startDate;
        params.endDate = endDate;
      } else {
        params.startRefundDate = startDate;
        params.endRefundDate = endDate;
      }

      const reportData = await financialReportingServiceConnector.generateRefundReport(params);
      return reportData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'csvReport.generateRefundReportError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async generateCaptureReport(context, {
    dateType, startDate, endDate, sort, filename, payoutId, timezone,
  }) {
    try {
      const lang = context.rootGetters['language/selectedLanguage'];
      const params = { sort, filename, lang, payoutId, timezone };

      if (dateType === 'payoutDate') {
        params.startPayoutDate = startDate;
        params.endPayoutDate = endDate;
      } else {
        params.startCaptureDate = startDate;
        params.endCaptureDate = endDate;
      }

      const financialReportingServiceConnector = context.getters.financialReportingServiceConnector(context);
      const reportData = await financialReportingServiceConnector.generateCaptureReport(params);
      return reportData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'csvReport.generateCaptureReportError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async generatePayoutReport(context, {
    status, statusAtStart, statusAtEnd, sort, filename,
  }) {
    try {
      const lang = context.rootGetters['language/selectedLanguage'];
      const params = { sort, filename, lang, status, statusAtStart, statusAtEnd, timezone: 'local' };

      const financialReportingServiceConnector = context.getters.financialReportingServiceConnector(context);
      const reportData = await financialReportingServiceConnector.generatePayoutReport(params);
      return reportData;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'csvReport.generatePayoutReportError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
